import { AbstractApiService } from './abstract.api.service';
import { Injectable } from '@angular/core';
import { StorageService } from '../storage.service';
import { ApiManagerService } from './api-manager.api.service';
import {
  GET_ALL_ORDERS,
  GET_ALL_PROPOSALS,
  GET_PENDING_PROPOSALS,
  GET_PROPOSAL,
} from '../../lib/contsants';

@Injectable({
  providedIn: 'root',
})
export class ProposalsAndOrdersService extends AbstractApiService {
  constructor(storageService: StorageService, protected apiManager: ApiManagerService) {
    super(storageService);
  }

  protected getApi(endpoint) {
    return this.apiManager.apiBuilder(endpoint);
  }

  async getOrders() {
    const data = await this.get(this.getApi(GET_ALL_ORDERS));
    return data;
  }

  async getProposals() {
    const data = await this.get(this.getApi(GET_ALL_PROPOSALS));
    return data;
  }

  async getPendingProposals() {
    const data = await this.get(this.getApi(GET_PENDING_PROPOSALS));
    return data;
  }

  async getProposal(proposalId) {
    const data = await this.get(this.getApi(`${GET_PROPOSAL}${proposalId}`));
    return data.data;
  }
}
